import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import "./LicenseCard.css";
import { data, useSearchParams } from "react-router-dom";

const LicenseCard = () => {
 const [searchParams] = useSearchParams();
 const [parsedData , setParsedData] = useState(null)


  const downloadImage = () => {
    const element = document.querySelector(".license-card"); // Select the license card div
    html2canvas(element).then((canvas) => {
      const image = canvas.toDataURL("image/png"); // Convert the canvas to an image
      const link = document.createElement("a");
      link.href = image;
      link.download = "license-card.png"; // Set the download name
      link.click(); // Trigger the download
    });
  };

  useEffect(() => {
 let data = searchParams.get("data"); 
   setParsedData(JSON.parse(data))
   
  } , [])

  return (
    <div className="license-card">
      <h2 className="search-results">Search Results - 1 licence found</h2>
       {parsedData && <div className="card-grid">
        <div className="card-item first-name">
          <div className="label">First name</div>
          <div className="value">{parsedData.first_name}</div>
        </div>
        <div className="card-item surname">
          <div className="label">Surname</div>
          <div className="value">{parsedData.surname}</div>
        </div>

        <div className="card-item role">
          <div className="label">Role</div>
          <div className="value">{parsedData.role}</div>
        </div>
        <div className="card-item licence-number">
          <div className="label">Licence number</div>
          <div className="value">{parsedData.licence_number}</div>
        </div>
        <div className="card-item licence-sector">
          <div className="label">Licence sector</div>
          <div className="value">{parsedData.licence_sector}</div>
        </div>

        <div className="card-item expiry-date">
          <div className="label">Expiry date</div>
          <div className="value">{parsedData.expiry_date}</div>
        </div>
        <div className="card-item status-explanation">
          <div className="label">Status explanation</div>
          <div className="value">{parsedData.status_explanation || "-"}</div>
        </div>

        <div className="card-item status">
          <div className="label">Status</div>
          <div className="value active-status">
            {parsedData.status.value}{" "}
            <div className="status-date">(as on {parsedData.status.as_on_date})</div>
          </div>
        </div>
        <div className="card-item additional-conditions">
          <div className="label">Additional licence conditions</div>
          <div className="value">
            {parsedData.additional_licence_conditions || "-"}
          </div>
        </div>
    </div>}
      <button onClick={downloadImage}>Download as Image</button>
    </div>
  );
};

export default LicenseCard;
